module.exports = __webpack_public_path__ + "static/img/logo.5fe9731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/icon/logo.jpg
// module id = Da1p
// module chunks = 11